import { AuthGuard } from "../../shared/guards/AuthGuard";
import { Sidebar } from "../../shared/components";
import { ListagemDetalhesContratoPresentation } from "./components";

export const ListagemDetalhesContratoPage = (): JSX.Element => {
	return (
		<AuthGuard>
			<Sidebar>
				<ListagemDetalhesContratoPresentation />
			</Sidebar>
		</AuthGuard>
	);
};
